<template>
    <div class="contactUs">
        <div class="phone_information">
            <h1>{{$t('company')}}</h1>
            <table>
                <tr>
                    <td class="phone_td">{{$t('contact_tel')}}</td>
                    <td></td>
                </tr>
                <tr>
                    <td>{{$t('hotline')}}</td>
                    <td><a href="tel:0757-27331088">0757-27331088</a></td>
                </tr>
                <tr>
                    <td>{{$t('switchboard')}}</td>
                    <td><a href="tel:0757-27331111">0757-27331111</a>
                        <p>{{$t('hotline_tip')}}</p>
                    </td>

                </tr>
                <tr>
                    <td>{{$t('complaints_hotline')}}</td>
                    <td><a href="tel:0757-27339988">0757-27339988</a></td>

                </tr>
                <tr>
                    <td>{{$t('Medical_phone')}}</td>
                    <td><a href="tel:0757-27331674">0757-27331674</a></td>
                </tr>
                <tr>
                    <td>{{$t('house_phone')}}</td>
                    <td><a href="tel:0757-27331959">0757-27331959</a></td>
                </tr>


            </table>
        </div>
        <div class="address_information">
            <table>
                <tr>
                    <td class="address_td">{{$t('address')}}</td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="2">{{$t('all_address')}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
export default {
  name: "contactUs",
  created() {
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "footerNav[2]");
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";

.contactUs {
  width: @width;
  .media;
  table {
    font-size: @font;
    width: 100%;
    tr:first-child {
      height: 40px;
    }
    td:first-child {
      width: 35%;
      padding-left: 40px;
      line-height: 35px;
      padding-right: 10px;
      .box-sizing;
      @media (max-width: 360px) {
        width: 36%;
      }
      @media (max-width: 320px) {
        width: 43%;
      }
    }
    td:last-child {
      a {
        color: #2b86e3;
      }
      p {
        font-size: 0.6rem;
      }
    }
  }
  .phone_td,
  .address_td {
    position: relative;
    &:before {
      content: "";
      top: 0;
      left: 0;
      width: 30px;
      height: 35px;
      background: url("../../assets/images/endPage/endPage_sprite.png")
        no-repeat;
      background-position-x: -14px;
      background-size: 55px auto;
    }
  }
  .phone_td:before {
    background-position-y: -129px;
  }
  .address_td {
    &:before {
      background-position-y: -169px;
    }
  }
  .address_information tr:last-child td {
    padding-left: 12%;
    line-height: 20px;
    text-align: left;
    @media (min-width: 768px) {
      padding-left: 6%;
    }
  }
}
.phone_information {
  .box-sizing;
  padding: 20px;
  .border-bottom(5px; @bg);
  h1 {
    font-size: @font + 0.4;
    line-height: 50px;
    @media (max-width: 320px) {
      line-height: 33px;
    }
  }
  td:first-child {
    text-align: justify;
    text-align-last: justify;
  }
}
.address_information {
  .box-sizing;
  padding: 20px 5px 20px 20px;
}
</style>
